import { apiSlice } from "../../app/apiSlice"

export const privacyPolicyApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getPrivacyPolicy: build.query<any, void>({
      query: () => ({
        url: "/privacy-policies/public/gift_cards",
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetPrivacyPolicyQuery,
} = privacyPolicyApiSlice
